var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.mergedClasses,attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.$slots.icon)?_vm._t("icon"):_vm._e(),_vm._t("default"),(_vm.$slots.iconRight)?_vm._t("iconRight"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }